import { Link } from 'react-router-dom';
import { Clock, ArrowRight } from 'lucide-react';

const MAX_RECENT = 6;
const STORAGE_KEY = 'cp_recently_viewed';

export const getRecentlyViewed = () => {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data) : [];
  } catch {
    return [];
  }
};

export const addRecentlyViewed = (product) => {
  try {
    const recent = getRecentlyViewed();
    const filtered = recent.filter((p) => p.id !== product.id);
    const updated = [
      { id: product.id, name: product.name, dosage: product.dosage, price: product.price, image: product.image, category: product.category },
      ...filtered,
    ].slice(0, MAX_RECENT);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  } catch (err) {
    console.error('localStorage write failed:', err);
  }
};

export const RecentlyViewed = () => {
  const items = getRecentlyViewed();

  if (items.length === 0) return null;

  return (
    <section className="py-16 bg-[#0A0A0A]" data-testid="recently-viewed-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-3 mb-8">
          <Clock size={22} className="text-[#D4AF37]" />
          <h2 className="font-['Oswald'] text-2xl md:text-3xl font-bold uppercase tracking-tight text-white">
            Recently <span className="text-[#C41E3A]">Viewed</span>
          </h2>
        </div>

        <div
          className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4"
          data-testid="recently-viewed-grid"
        >
          {items.map((item) => (
            <Link
              key={item.id}
              to={`/product/${item.id}`}
              className="group bg-[#121212] border border-[#27272A] rounded-sm overflow-hidden hover:border-[#C41E3A] transition-all duration-300"
              data-testid={`recent-item-${item.id}`}
            >
              <div className="relative h-32 overflow-hidden bg-[#0A0A0A]">
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
              </div>
              <div className="p-3">
                <h3 className="font-['Oswald'] text-sm uppercase tracking-wide text-white mb-1 group-hover:text-[#C41E3A] transition-colors line-clamp-1">
                  {item.name}
                </h3>
                <div className="flex justify-between items-center">
                  <span className="text-[#D4AF37] text-xs">{item.dosage}</span>
                  <span className="text-[#C41E3A] text-sm font-bold">{item.price}</span>
                </div>
                <div className="flex items-center text-[#C41E3A] text-xs font-semibold uppercase tracking-wider mt-2 group-hover:translate-x-1 transition-transform">
                  <span>View</span>
                  <ArrowRight size={12} className="ml-1" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
